import React, { ComponentType } from 'react'
import { ButtonComp, ButtonProps } from 'src/ui/basic/api/Button'
import { css } from 'src/ui/style/css'
import { Theme } from 'src/ui/style/Theme'
import { darken } from 'polished'
import { useTheme } from 'src/ui/style/useTheme'

type ButtonStyleParams = {
    color: string
    enabled?: boolean
    outline: boolean
    uppercase?: boolean
    hoverable?: boolean
}

export const buttonStyle =
    ({
        color,
        enabled = true,
        outline,
        hoverable = true,
        uppercase = true
    }: ButtonStyleParams) =>
    (th: Theme) => {
        let buttonBgColor = th.colors.gray
        let buttonHoverBgColor = 'inherit'
        let buttonBorderColor = th.colors.gray
        let buttonHoverBorderColor = 'inherit'
        let buttonTextColor = th.colors.white
        let buttonHoverTextColor = 'inherit'
        if (enabled) {
            const hoverColorByType = darken(0.08, color)
            buttonBgColor = outline ? 'transparent' : color
            buttonHoverBgColor = outline ? color : hoverColorByType
            buttonBorderColor = color
            buttonHoverBorderColor = outline ? color : hoverColorByType
            buttonTextColor = outline ? color : th.colors.white
            buttonHoverTextColor = th.colors.white
        }
        const textTransform = uppercase ? 'uppercase' : 'none'

        return css`
            border: 1px solid ${buttonBorderColor};
            background: ${buttonBgColor};
            padding: 0.5em 1em;
            font-size: ${th.fontSize.sm};
            font-weight: ${th.fontWeight.bold};
            text-transform: ${textTransform};
            color: ${buttonTextColor};
            cursor: ${enabled ? 'pointer' : 'default'};
            border-radius: ${th.borderRadius.primary};
            box-shadow: ${th.boxShadow.bottomOnly};
            display: flex;
            align-items: center;
            justify-content: center;

            > *:nth-child(2) {
                margin-left: 0.5em;
            }

            ${enabled &&
            hoverable &&
            `&:hover {
                    background: ${buttonHoverBgColor};
                    color: ${buttonHoverTextColor};
                    border: 1px solid ${buttonHoverBorderColor};
                }`}
        `
    }
export const Button: ButtonComp = ({
    id,
    children,
    onClick,
    enabled = true,
    color = 'primary',
    outline = false,
    leftContent,
    submittable,
    uppercase = false,
    className,
    alwaysEnabled = false
}) => {
    const th = useTheme()
    // @ts-ignore
    const colorByType = th.colors[color]
    return (
        <button
            id={id}
            disabled={!enabled && !alwaysEnabled}
            css={buttonStyle({
                enabled: enabled,
                color: colorByType,
                outline,
                uppercase
            })}
            className={className}
            onClick={onClick}
            type={submittable ? 'submit' : 'button'}
        >
            {leftContent && leftContent()}
            <span>{children}</span>
        </button>
    )
}

export type NoClickButtonProps = Omit<ButtonProps, 'onClick'>

export const NoClickButton: ComponentType<NoClickButtonProps> = ({
    ...rest
}) => (
    // @ts-ignore
    <Button onClick={null} {...rest} />
)
